import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { textStyleKeys } from '~/themes/textStyles'
import { Size } from '~/types/ThemeTypes'
import { useMessageGroupsViewModel } from '~/viewModels/Messaging/MessageGroupsViewModel'

const MarkReadModal = () => {
  const { messagingMarkAllReadModal: chatMarkAllReadModal } = useModalState()
  const { markAllMessageGroupsAsRead } = useMessageGroupsViewModel()
  const { t } = useTranslation()

  const [renderState, setRenderState] = chatMarkAllReadModal
  const handleCloseModal = () => {
    setRenderState({ ...renderState, open: false })
  }

  const handleMarkAsRead = () => {
    markAllMessageGroupsAsRead()
    handleCloseModal()
    window.gtag('event', 'mark_all_as_read', {})
  }

  return (
    <MangoModal
      isOpen={renderState.open}
      size={Size.md}
      header={t('markReadModal.header')}
      onClose={handleCloseModal}
      footer={
        <MangoButton onClick={handleMarkAsRead}>
          {t('markReadModal.confirmButton')}
        </MangoButton>
      }
    >
      <Box minHeight="3rem">
        <Text textStyle={textStyleKeys.Body1} align="center">
          {t('markReadModal.message')}
        </Text>
        <Text textStyle={textStyleKeys.Body1} align="center">
          {t('markReadModal.confirmText')}
        </Text>
      </Box>
    </MangoModal>
  )
}

export default MarkReadModal
